<template>
  <div class="view">
    <Header title="Pick" :backLink="$route.params.orderId ? '/pick' : '/'" />
    <div class="content">
      <div class="content__inner">
        <Picker v-if="$route.params.orderId" />
        <div v-else>
          <h5 class="headline">Offene Bestellungen</h5>
          <div class="list-group" v-if="$store.state.organizationsLoaded">
            <router-link
              v-for="order in $store.state.orders"
              :key="order.id"
              :to="`/pick/${order.id}`"
              class="list-group-item list-group-item-action d-flex justify-content-between"
            >
              <span>{{$store.getters.organizationName(order.organizationId)}}</span>
              <small>{{ order.id }}</small>
            </router-link>
          </div>
        </div>
        <ul></ul>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Picker from '@/components/Picker'
// import { fb, db } from '@/shared/firebase'

export default {
  data() {
    return {}
  },
  components: { Header, Picker }
}
</script>

<style lang="scss" scoped></style>
